/**
 * Supabase client configuration for public live results page
 * This client uses the anonymous key and is safe for browser use
 */

import { createClient } from '@supabase/supabase-js';

// Validate environment variables are present
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Log which Supabase instance is being used (helpful for debugging)
if (import.meta.env.DEV) {
  console.log('🔗 Supabase URL:', supabaseUrl);
  console.log('🔑 Using mode:', import.meta.env.MODE);
}

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase environment variables. Please check your .env file contains VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY'
  );
}

/**
 * Supabase client instance
 * Configured for public read-only access to race data
 */
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: false, // No authentication needed for public page
  },
  realtime: {
    params: {
      eventsPerSecond: 10, // Limit realtime event frequency
    },
  },
  db: {
    schema: 'public',
  },
  global: {
    headers: {
      // Override PostgREST's default limit to allow fetching up to 50,000 rows
      // This matches the Max rows setting in Supabase dashboard
      'Range-Unit': 'items',
    },
  },
});

